import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { formatFileSize } from '../../../core/utils/file';
import { TruncateFilenameDirective } from '../../directives';
import { type SupportFile } from '../support-file';

@Component({
  selector: 'app-support-attachment',
  templateUrl: './support-attachment.component.html',
  styleUrl: './support-attachment.component.scss',
  imports: [MatProgressSpinner, TruncateFilenameDirective],
  host: {
    '[class.uploading]': 'isUploading()',
    '[class.has-error]': 'hasError()'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportAttachmentComponent {
  public readonly attachment = input.required<SupportFile>();
  public readonly disabled = input(false, { transform: booleanAttribute });
  public readonly hasError = input(false, { transform: booleanAttribute });

  public readonly remove = output<void>();

  public readonly isUploading = computed(() => !this.attachment().file);

  public readonly filename = computed(
    () => this.attachment()?.file?.fileName || (this.attachment()?.task?.originalFile as File)?.name || ''
  );

  public readonly filesize = computed(() => {
    const size = this.attachment()?.task?.originalFile?.size;
    return size ? formatFileSize(size) : '';
  });

  public readonly url = computed(() => this.attachment()?.file?.url ?? null);

  public readonly href = computed(() => (this.isUploading() ? null : this.url()));

  public readonly progress = toSignal(
    toObservable(this.attachment).pipe(switchMap(att => att?.task?.progress$?.pipe(map(p => p ?? 0)) ?? of(0))),
    { initialValue: 0 }
  );

  public handleDelete(): void {
    if (!this.disabled()) {
      this.remove.emit();
    }
  }
}
